var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeJatMed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91299 0.400992C8.92099 0.400992 9.92999 0.387994 10.938 0.404994C12.017 0.422994 13.098 0.436993 14.173 0.561993C14.565 0.607993 14.868 0.808993 15.108 1.11099C15.522 1.63299 15.673 2.25999 15.794 2.89399C15.936 3.63699 15.994 4.39099 15.995 5.14699C15.996 6.04199 16.024 6.93799 15.955 7.83199C15.895 8.61299 15.79 9.38599 15.524 10.13C15.206 11.02 14.589 11.438 13.637 11.492C10.707 11.659 7.77699 11.595 4.84599 11.59C3.86699 11.588 2.88599 11.533 1.90999 11.437C1.33099 11.381 0.943986 11.032 0.670986 10.544C0.350986 9.97199 0.238987 9.33599 0.141987 8.69999C-0.0670132 7.32199 0.0119865 5.93299 0.0349865 4.54999C0.0479865 3.79199 0.127986 3.02899 0.337986 2.28999C0.422986 1.98899 0.550986 1.70599 0.687986 1.42499C0.989986 0.802992 1.51899 0.571993 2.16899 0.520993C4.07999 0.370993 5.99699 0.399992 7.91299 0.400992Z",
    fill: "#32976B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42599 8.89703L10.928 6.00003L6.42599 3.10303V8.89703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeJatMed);
export default __webpack_public_path__ + "static/media/youtube_jat-med.620ee5ba22bfd4fa4f5d3f33bb6c2090.svg";
export { ForwardRef as ReactComponent };